<div
    class="carousel"
    [style]="`
    --carousel-height: ${block.data.carouselHeight};
    --bg-color: var(--color-${block.data.theme});
    --text-color: ${block.data.textColor};
    `">
    <swiper #swiperRef [config]="swiperConfig">
        @for (item of block.content; track item.id) {
            <div swiperSlide>
                <div class="carousel-slide" [class.carousel-slide--image-left]="item.data.imagePosition === 'left'">
                    <div class="carousel-slide__content">
                        @if (item.data.heading) {
                            <h2 class="carousel-slide__heading">
                                {{ item.data.heading }}
                            </h2>
                        }

                        @if (item.data.description) {
                            <div class="carousel-slide__description" [innerHTML]="item.data.description"></div>
                        }

                        @if (item.data.includeCTA && item.data.ctaText && item.data.ctaUrl) {
                            @if (item.data.isCtaExternalLink) {
                                <a
                                    class="btn btn-primary carousel-slide__cta"
                                    [href]="item.data.ctaUrl"
                                    target="_blank">
                                    <span [innerText]="item.data.ctaText | translate"></span>
                                    <core-icon [name]="item.data.buttonIcon"></core-icon>
                                </a>
                            } @else {
                                <a class="btn btn-primary carousel-slide__cta" [routerLink]="item.data.ctaUrl">
                                    <span [innerText]="item.data.ctaText | translate"></span>
                                    <core-icon [name]="item.data.buttonIcon"></core-icon>
                                </a>
                            }
                        }
                    </div>

                    @if (item.data.image) {
                        <div class="carousel-slide__image-wrapper">
                            <img
                                class="carousel-slide__image"
                                [src]="item.data.image"
                                [alt]="item.data.altText || ''" />
                        </div>
                    }
                </div>
            </div>
        }
    </swiper>

    @if (block.content.length > 1) {
        <button class="carousel-nav carousel-nav--prev" (click)="prev()" aria-label="Previous slide">
            <core-icon [name]="'chevron-left-single'"></core-icon>
        </button>

        <button class="carousel-nav carousel-nav--next" (click)="next()" aria-label="Next slide">
            <core-icon [name]="'chevron-right-single'"></core-icon>
        </button>
    }

    <div class="carousel-pagination"></div>
</div>
